import { connect } from 'react-redux'
import { InsertComponent } from './InsertComponent'
import type { Dispatch } from 'redux'
import type { RootState } from 'shared/store/reducers'
import { closeInsert } from 'shared/store/user'

const mapStateToProps = (state: RootState) => {
    const { appBannerClosed } = state.userState
    const {
        appInsertEnabled,
        appInsertCloseTime,
        appInsertViewCloseTime
    } = state.applicationState
    const showAppBanner = appInsertEnabled && !appBannerClosed
    return {
        appInsertEnabled,
        appInsertCloseTime,
        appInsertViewCloseTime,
        showAppBanner
    }
}

const mapDispatchToProps = (d: Dispatch<any>) => ({
    closeInsert: () => d(closeInsert())
})

const Insert = connect(mapStateToProps, mapDispatchToProps)(InsertComponent)

export { Insert }
